import { createApp } from 'vue'
import { createPinia } from 'pinia'
import FloatingVue from 'floating-vue'
import App from './App.vue'
import 'floating-vue/dist/style.css'

const mountEl = document.querySelector('#electrictiy-bill-calculator-container');
const app = createApp(App, { ...mountEl.dataset });
app.use(createPinia())
app.use(FloatingVue, {
    themes: {
      'info-tooltip': {
        triggers: ['click'],
        autoHide: true,
        placement: 'auto',
      },
    },
  }
)

app.mount(mountEl)